/**
 * @generated SignedSource<<0059c367431a33a75de83f8ef6e2083d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type JiraCustomBackgroundBrightness = "DARK" | "LIGHT" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type ThemeSetterBackground$data = {
  readonly __typename: "JiraColorBackground";
  readonly colorValue: string | null;
  readonly " $fragmentType": "ThemeSetterBackground";
} | {
  readonly __typename: "JiraGradientBackground";
  readonly gradientValue: string | null;
  readonly " $fragmentType": "ThemeSetterBackground";
} | {
  readonly __typename: "JiraMediaBackground";
  readonly customBackground: {
    readonly altText: string | null;
    readonly brightness: JiraCustomBackgroundBrightness | null;
    readonly dominantColor: string | null;
    readonly id: string | null;
    readonly mediaApiFileId: string | null;
    readonly mediaReadToken: string | null;
    readonly sourceIdentifier: string | null;
    readonly sourceType: string | null;
  } | null;
  readonly " $fragmentType": "ThemeSetterBackground";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "ThemeSetterBackground";
};
export type ThemeSetterBackground$key = {
  readonly " $data"?: ThemeSetterBackground$data;
  readonly " $fragmentSpreads": FragmentRefs<"ThemeSetterBackground">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ThemeSetterBackground",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "colorValue"
        }
      ],
      "type": "JiraColorBackground"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "gradientValue"
        }
      ],
      "type": "JiraGradientBackground"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraCustomBackground",
          "kind": "LinkedField",
          "name": "customBackground",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "id"
            },
            {
              "kind": "ScalarField",
              "name": "mediaApiFileId"
            },
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "durationInSeconds",
                  "value": 900
                }
              ],
              "kind": "ScalarField",
              "name": "mediaReadToken",
              "storageKey": "mediaReadToken(durationInSeconds:900)"
            },
            {
              "kind": "ScalarField",
              "name": "sourceType"
            },
            {
              "kind": "ScalarField",
              "name": "sourceIdentifier"
            },
            {
              "kind": "ScalarField",
              "name": "altText"
            },
            {
              "kind": "ScalarField",
              "name": "dominantColor"
            },
            {
              "kind": "ScalarField",
              "name": "brightness"
            }
          ]
        }
      ],
      "type": "JiraMediaBackground"
    }
  ],
  "type": "JiraActiveBackgroundDetailsResult",
  "abstractKey": "__isJiraActiveBackgroundDetailsResult"
};

(node as any).hash = "3c41e5a508924f980b8234232721902b";

export default node;
